import React from "react";
import AdminGenericCRUDPage from "./AdminGenericCRUDPage";

const FIELDS = [
  { name: "name",     label: "Ad Soyad", required: true },
  { name: "role",     label: "Rol", required: true },
  { name: "avatar",   label: "Profil Fotoğrafı", type: "image" },
  { name: "bio",      label: "Kısa Biyografi", type: "textarea", rows: 3 },
  { name: "linkedin", label: "LinkedIn URL", type: "url" },
  { name: "email",    label: "E-posta" },
  { name: "order",    label: "Sıra", type: "number" },
];

export default function AdminTeamPage() {
  return (
    <AdminGenericCRUDPage
      title="Ekip"
      subtitle="About sayfasında gösterilecek ekip üyeleri"
      endpoint="/admin/team"
      identifier="id"
      fields={FIELDS}
      defaultItem={{ name: "", role: "", avatar: "", bio: "", linkedin: "", email: "", order: 0 }}
      testIdPrefix="team"
    />
  );
}
